import React from "react";
import Buydetails from "Pages/Buydetails";


const Buytrasadetails = () => {
  return (
    <React.Fragment>
       <Buydetails/>
    </React.Fragment>
  );
};

export default Buytrasadetails;
